import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../public/assets/icon/icon-solo.png'


const _withScopeId = n => (_pushScopeId("data-v-b644492a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-header-bg" }
const _hoisted_2 = { class: "header-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Bienvenid@", -1))
const _hoisted_5 = {
  key: 0,
  style: {"float":"right","color":"#d9514e","font-weight":"600"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_menu = _resolveComponent("ion-menu")!
  const _component_ion_back_button = _resolveComponent("ion-back-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, {
      collapse: _ctx.condense,
      class: _normalizeClass(_ctx.cssClass)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, { color: "nix-farma" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openMenu()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      size: "large",
                      icon: _ctx.menuOutline,
                      slot: "start"
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_title, {
              class: "ion-no-padding",
              size: _ctx.sizeTitle,
              slot: "start"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.pageTitle), 1)
              ]),
              _: 1
            }, 8, ["size"]),
            _createVNode(_component_ion_buttons, { slot: "end" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openNotifications()))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _createVNode(_component_ion_icon, {
                        size: "large",
                        icon: _ctx.notificationsOutline,
                        slot: "end"
                      }, null, 8, ["icon"]),
                      (_ctx.store.notificacionesSinLeer > 0)
                        ? (_openBlock(), _createBlock(_component_ion_badge, {
                            key: 0,
                            slot: "end",
                            class: "badge"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.store.notificacionesSinLeer), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_button, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openFilter()))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _createVNode(_component_ion_icon, {
                        size: "large",
                        icon: _ctx.optionsOutline,
                        slot: "end"
                      }, null, 8, ["icon"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["collapse", "class"]),
    _createVNode(_component_ion_menu, {
      "menu-id": "app-menu",
      side: "start",
      "content-id": "main"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_content, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.nombreFarmaciaFormateado), 1),
                    _hoisted_4
                  ]),
                  _: 1
                })
              ])
            ]),
            _createVNode(_component_ion_list, {
              lines: "none",
              class: "menu-items"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.tabs, (tab) => {
                  return (_openBlock(), _createBlock(_component_ion_item, {
                    key: tab.TabId,
                    onClick: ($event: any) => (_ctx.changeMenuSelected(tab.TabId, tab.TabNombre))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_component_ion_icon, {
                        icon: _ctx.getIcon(tab.TabIcon),
                        key: tab.TabIcon
                      }, null, 8, ["icon"])),
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tab.TabNombre), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_list, {
          lines: "none",
          class: "menu-items"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_item, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.logout()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, { icon: _ctx.exitOutline }, null, 8, ["icon"]),
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Cerrar sesión")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_menu, {
      id: "menu-notifications",
      "menu-id": "app-notifications",
      side: "end",
      "content-id": "main"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_header, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_toolbar, { color: "danger" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_buttons, { slot: "start" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_back_button, {
                      defaultHref: "home",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeNotifications()))
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Notificaciones")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_list, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.notificaciones, (notificacion) => {
                  return (_openBlock(), _createBlock(_component_ion_item, {
                    key: notificacion,
                    class: _normalizeClass([
            notificacion.NotificacionLeido === 1 ? 'notificacion_leida' : 'notificacion_no_leida',
          ])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", null, _toDisplayString(notificacion.NotificacionTitulo), 1),
                          _createElementVNode("p", null, _toDisplayString(notificacion.NotificacionDescripcion), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_label, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString(_ctx.format_date(notificacion.FechaDia)), 1),
                          (notificacion.NotificacionLeido === 0)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Nueva "))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["class"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}